import React from "react";
import PropTypes from "prop-types";
import ContentBuilder from "./ContentBuilder";
import { contentProps } from "./propTypes";

const Article = ({ content, handleAnchor, isNested = false }) => {
  if (!content) return null;

  const contentArray = Array.isArray(content) ? content : [content];

  return contentArray.map((item, idx) => (
    <ContentBuilder
      key={item.id || idx}
      number={idx}
      {...item}
      handleAnchor={handleAnchor}
      isNested={isNested}
    />
  ));
};

Article.propTypes = {
  content: contentProps.isRequired,
  handleAnchor: PropTypes.func.isRequired,
  isNested: PropTypes.bool,
};

export default Article;
